const misc = {
  updateDefaultRateMarkup: (app, teamId, rateMarkup) => {
    return app
      .service('/api/team')
      .patch(teamId, { defaultRateMarkup: rateMarkup })
      .then(result => {
        app.setDefaultRateMarkup(result.defaultRateMarkup)
      })
  },
  _createRateCard: (crud, rateCard, teamId) => {
    const createData = { ...rateCard, teamId }
    return crud.create(createData)
  },
  _updateRateCard: (crud, rateCard) => {
    const { id, ...updateData } = rateCard
    return crud.update(id, updateData, {})
  },
  _removeRateCards: (crud, rateCardIds) => {
    const params = {}
    return Promise.all(rateCardIds.map(x => crud.remove(x, params)))
  },
  _upsertRateCard: (crud, card, teamId) => {
    const fn = card.id ? misc._updateRateCard : misc._createRateCard
    return fn(crud, card, teamId)
  },
  _upsertRateCards: (crud, cards, teamId) => {
    return Promise.all(
      cards.map(card => misc._upsertRateCard(crud, card, teamId))
    )
  },
  saveRateCards: (crud, teamId, rateCards, rateCardIds, callback) => {
    const validCards = rateCards.filter(x => x.name)
    misc
      ._removeRateCards(crud, rateCardIds)
      .then(() => misc._upsertRateCards(crud, validCards, teamId))
      .then(() => callback())
      .catch(err => callback(err))
  },
  prepareRateCardsForStorage: (fromDb, fromForm, type, teamId) => {
    // This function is to convert between the new component and the code that services the old.
    // if it's in fromForm, but not FromDb, it's new. Strip the ID, add teamId and type. DONE
    // if it's in both, return the FromForm version DONE
    // if it's in fromDb, but not from Form, it's been deleted, so we return the id in a separate list
    const rateCards = []
    const rateCardIds = []

    // fromForm rateCards don;t have teamId and type, we need to add them before saving
    fromForm = fromForm.map(source => ({
      ...source,
      type,
      teamId
    }))

    fromForm.forEach(source => {
      if (!fromDb.find(target => source.id === target.id)) {
        const { id, ...stripped } = source
        rateCards.push(stripped)
      } else {
        rateCards.push(source)
      }
    })

    fromDb.forEach(source => {
      if (!fromForm.find(target => source.id === target.id)) {
        rateCardIds.push(source.id)
      }
    })

    const sanitizedRateCards = rateCards.map(x => {
      return {
        id: x.id,
        name: x.name,
        amount: x.amount,
        markupPercentage: x.markupPercentage,
        type: x.type,
        teamId: x.teamId
      }
    })
    return { rateCards: sanitizedRateCards, rateCardIds }
  },

  getRateCardsByType: (rateCards, type) =>
    rateCards.filter(rateCard => rateCard.type === type)
}

module.exports = misc
